import type {
  CandidateWithId,
  CreateCandidatePayload,
} from "@/resources/candidate";
import store from "@/store";
import { apiClient } from "./apiClient";

type CreateTicketPayload = {
  couponCode: string;
  couponPassword: string;
  learnerId: string;
  campaign?: string;
  package?: string;
};

class CandidateService {
  async create(
    candidate: CreateCandidatePayload,
  ): Promise<CandidateWithId | null> {
    try {
      const response = await apiClient.post<CandidateWithId>(
        "/candidates",
        candidate,
      );
      if (response.status === "OK" && response.result) {
        return response.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to create candidate:", error);
      return null;
    }
  }

  async createTicket(
    ticket: CreateTicketPayload,
    isTicketsForPreviouslyRegisteredCoupon?: boolean,
  ): Promise<boolean> {
    const candidateId = store.state.uid;
    try {
      const response = await apiClient.post<boolean>(
        `/candidates/${candidateId}/tickets`,
        ticket,
        { params: { isTicketsForPreviouslyRegisteredCoupon } },
      );
      return response.status === "OK";
    } catch (error) {
      console.error("Failed to create ticket:", error);
      return false;
    }
  }
}

export const candidateService = new CandidateService();
